module.exports = __webpack_public_path__ + "2789b96da5054db7483f0012dc25f87b.png";